import { HttpClient } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

export const HTTP_CLIENT_WITHOUT_AUTH = new InjectionToken<HttpClient>(
  'HTTP_CLIENT_WITHOUT_AUTH'
);
